import { render, staticRenderFns } from "./HelloWorld.vue?vue&type=template&id=126cc91c&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"
import style0 from "./HelloWorld.vue?vue&type=style&index=0&id=126cc91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126cc91c",
  null
  
)

export default component.exports